import { Component, OnInit,Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { WaterTankService } from 'app/shared/services/water-tank.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';


@Component({
  selector: 'ngx-water-tank',
  templateUrl: './water-tank.component.html',
  styleUrls: ['./water-tank.component.scss']
})
export class WaterTankComponent implements OnInit {

  form: FormGroup;
  showProcessingIndicator = false;
  hideBtn : boolean= true;
  isReadOnly : boolean= true;

  getData:any;

  validationMessages = {
    'date': { 'required': 'This field is required' },
    'liters': { 'required': 'This field is required' },
  };

  formErrors = {
    'date': "",
    'liters': "",
  };



  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<WaterTankComponent>,
    private fb: FormBuilder,
    private waterTankService: WaterTankService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private authService: AuthService,
    private router : Router,
   
   
  ) {  
     this.getData =data;
    }

  ngOnInit(): void {

    this.initFormFields();
    this.getTableRowData(this.getData);


  } // end Oninit



  initFormFields(){
    this.form = this.fb.group({
      id: [null],
      date: ['',Validators.required],
      liters: ['', Validators.required],
      createdBy: [''],

    });

  }


 newButtonClick(): void {
    this.isReadOnly = false;
    this.enableForm();
    this.form.reset();
    this.resetValiationErrors();

   }

   onClose(){
    this.form.reset();
    this.dialogRef.close();
   }



  saveButtonClick(): void {
    var data: any;
    
    this.logValidationErrors(this.form, true);
    const formData = this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

        this.showProcessingIndicator = true;
        this.waterTankService.create(formData)
          .subscribe(
            (res) => {
              data = res;
                this.toastr.success('Record created successfully', 'Success');               
                this.showProcessingIndicator = false;   
                this.onClose(); 
              
                
            },
            (err) => {
              this.toastr.error('Failed to create record', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )

    }
    else {
      this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
      this.showProcessingIndicator = false;

    }


  }


  enableForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
     // console.log(key)
    });
  }



  resetValiationErrors(){
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.form, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    let formData ={
      ...this.form.value,
      date : this.form.value.date ? moment(this.form.value.date).format("YYYY-MM-DD") : null,
      createdBy : this.authService.getUserLoggedIn(),
    }
    return formData;

  }



  getTableRowData(data) {
    if (data) {
      this.form.patchValue({
        date: data.Date ? moment(data.Date).format("YYYY-MM-DD") : null,
        liters: data.Liters 
      });
      this.isReadOnly = true;
      this.hideBtn = false;
    }else{
      this.newButtonClick();
    }


  }




}// end class
